import { render, staticRenderFns } from "./TariffSettings.vue?vue&type=template&id=71d37af2&"
import script from "./TariffSettings.vue?vue&type=script&lang=ts&"
export * from "./TariffSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports